import React from 'react';
import { useFavoriteFilters as useFavoriteFiltersDI } from '@atlassian/jira-favorites-store/src/index.tsx';
import { useRecentFilters as useRecentFiltersDI } from '@atlassian/jira-recents-store/src/index.tsx';
import { LoadStatus as LoadStatusCommonDI } from '../../../../common/ui/load-status/main.tsx';
import type { LoadStatusProps } from './types.tsx';

export const LoadStatus = ({
	LoadStatusCommon = LoadStatusCommonDI,
	shouldThrowError = false,
	useFavorite = useFavoriteFiltersDI,
	useRecent = useRecentFiltersDI,
}: LoadStatusProps) => (
	<>
		<LoadStatusCommon shouldThrowError={shouldThrowError} useProvider={useFavorite} />
		<LoadStatusCommon shouldThrowError={shouldThrowError} useProvider={useRecent} />
	</>
);
